import ResponsiveModal from "@/modules/common/components/ui-kit/modals/responsive-modal";
import PermissionGuard from "@/modules/common/components/wrappers/permission-guard";
import { NawyPassportContext } from "@/modules/common/context/nawy-passport.provider";
import { PermissionLevel, PermissionsEnum } from "@/modules/common/types";
import {
  userHasPermission,
  formatDateTimeWithDayFirst,
} from "@/modules/common/utils";
import EditDateOfLastContact from "@/modules/lead-page/components/lead-info/edit-fields/date-of-last-contact";
import useLeadInfo from "@/modules/lead-page/hooks/lead-info/lead-info.hook";
import LeadInfoField from "@/modules/lead-page/new/components/lead-info-field";
import FieldWrapper from "@/modules/lead-page/new/components/sidebar/fields/field-wrapper";
import { Typography, useTheme } from "@mui/material";
import { useContext } from "react";

const LastContactField = () => {
  const theme = useTheme();
  const { dateOfLastContact, lead, isLoading, handleConfirmUpdate } =
    useLeadInfo();
  const { permissions: currentUserPermissions } =
    useContext(NawyPassportContext);

  return (
    <LeadInfoField
      editModalOpen={dateOfLastContact.editLeadDateOfLastContactModalOpen}
      setEditModalOpen={dateOfLastContact.setEditLeadDateOfLastContactModalOpen}
      editable={userHasPermission(
        {
          name: PermissionsEnum.JOURNEY_DATE_OF_LAST_CONTACT,
          level: PermissionLevel.WRITE,
        },
        currentUserPermissions
      )}
      content={
        <Typography
          sx={{
            ...theme.nawy.typography.english.variants.body.md.regular,
            display: "inline",
            whiteSpace: "nowrap",
          }}
        >
          {lead?.data?.lead?.date_of_last_contact
            ? formatDateTimeWithDayFirst(lead?.data?.lead?.date_of_last_contact)
            : "Not Set"}
        </Typography>
      }
      editModal={
        <PermissionGuard
          permissions={[
            {
              name: PermissionsEnum.JOURNEY_DATE_OF_LAST_CONTACT,
              level: PermissionLevel.WRITE,
            },
          ]}
        >
          <ResponsiveModal
            open={dateOfLastContact.editLeadDateOfLastContactModalOpen}
            onClose={() => {
              dateOfLastContact.setEditLeadDateOfLastContactModalOpen(false);
              dateOfLastContact.setState(null);
            }}
            onConfirm={() => {
              handleConfirmUpdate({
                journey: {
                  dateOfLastContact: dateOfLastContact.state ?? undefined,
                },
              });
              dateOfLastContact.setState(null);
            }}
            isConfirmDisabled={!dateOfLastContact.state}
            isLoading={isLoading}
            title="Select Date"
            confirmButtonText="Save"
            cancelButtonText="Cancel"
            snapPoints={[1]}
          >
            <FieldWrapper>
              <EditDateOfLastContact
                autoFocus
                dateOfLastContact={dateOfLastContact}
              />
            </FieldWrapper>
          </ResponsiveModal>
        </PermissionGuard>
      }
    />
  );
};

export default LastContactField;
